import { render, staticRenderFns } from "./modalLicenceTest.vue?vue&type=template&id=45390c18&scoped=true"
import script from "./modalLicenceTest.vue?vue&type=script&lang=js"
export * from "./modalLicenceTest.vue?vue&type=script&lang=js"
import style0 from "./modalLicenceTest.vue?vue&type=style&index=0&id=45390c18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45390c18",
  null
  
)

export default component.exports